<template>
    <div>
        <div class="p-3 grid grid-cols-3 gap-4">
            <div>
                <p class="text-2xl text-main-600 py-2">
                    {{ $t('labels.customer') }}
                </p>
                <p class="font-bold">
                    {{ trip.customerData?.name }}
                </p>
                <p v-if="trip.customerData?.address">
                    Địa chỉ: {{ trip.customerData.address }}
                </p>
                <p v-if="trip.contactData?.name">
                    {{ $t('labels.businessContact') }}: {{ trip.contactData?.name }} - {{ trip.contactData?.phone }} - {{ trip.contactData?.email }}
                </p>
                <p v-if="trip.logisticContactData?.name">
                    {{ $t('labels.logisticContact') }}: {{ trip.logisticContactData?.name }} - {{ trip.logisticContactData?.phone }} -
                    {{ trip.logisticContactData?.email }}
                </p>

                <div>
                    <div>
                        <p class="text-2xl text-main-600 pt-5 py-2">
                            {{ $t('labels.moderationStatus') }}
                        </p>
                        <status
                            :status="trip.moderationStatus"
                            module="tripModerationStatus"
                            key-status="moderationStatus"
                            label="" />
                    </div>
                    <div>
                        <p class="text-2xl text-main-600 pt-5 py-2">
                            {{ $t('labels.shippingStatus') }}
                        </p>
                        <status
                            :status="trip.status"
                            module="tripStatus"
                            key-status="status"
                            label="" />
                    </div>
                </div>
            </div>
            <div>
                <p class="text-2xl text-main-600 pt-5 py-2">
                    {{ $t('labels.route') }}
                </p>
                <ul
                    v-if="trip.positions && trip.positions.length"
                    class="steps steps-vertical w-full">
                    <li
                        v-for="(item, index) in (trip.positions as any[])"
                        :key="index"
                        data-content=" "
                        class="step float w-full">
                        <div class="flex items-center justify-center w-full">
                            <div class="items-center w-full text-left">
                                <p class="font-bold">
                                    {{ item.fullNameNode }}
                                </p>
                                <p
                                    v-if="item.locationName"
                                    class="pt-1">
                                    {{ item.locationName }}
                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div>
                <p class="text-2xl text-main-600 pt-5 py-2">
                    {{ $t('labels.otherInformation') }}
                </p>
                <p class="font-bold mt-2">
                    {{ $t('labels.commodity') }}
                </p>
                <p class="mb-2">
                    <span class="text-no first-letter:capitalize">
                        {{ dataOrder.commodityCategory }}
                    </span>
                    <span v-if="dataOrder.commodityCategory">
                        :
                    </span>
                    <span class="first-letter:capitalize">
                        {{ dataOrder.commodityName }}
                    </span>
                    <span v-if="dataOrder.goodsStatusName">
                        -
                    </span>
                    <span class="first-letter:capitalize">
                        {{ dataOrder.goodsStatusName }}
                    </span>
                </p>

                <template v-if="dataOrder.transportation === 'NON_CONTAINER'">
                    <p class="font-bold mt-2">
                        {{ $t('labels.vehicleType') }}
                    </p>
                    <p class="mb-2">
                        {{ dataOrder.vehicleCategoryName }}
                    </p>
                </template>
                <template v-else>
                    <p class="font-bold mt-2">
                        {{ $t('labels.containerType') }}
                    </p>
                    <p class="mb-2">
                        <span>
                            {{ dataOrder.contCategory }} feet
                        </span>
                        <span v-if="dataOrder.headContainer || dataOrder.mergeContainer">
                            - {{ dataOrder.headContainer ? `${$t('labels.headContainer')}` : '' }}{{ dataOrder.headContainer && dataOrder.mergeContainer ? ',' : ''
                            }}{{ dataOrder.mergeContainer ? `${$t('labels.mergeContainer')} ` : '' }}
                        </span>
                    </p>
                </template>

                <p class="font-bold mt-2">
                    {{ $t('labels.productivity') }}
                </p>
                <p class="mb-2">
                    {{ $formatters.formatNumber(dataOrder.productivityOrder || 0) }}
                    {{ dataOrder.transportation === 'NON_CONTAINER' ? $t('labels.vehicle') : $t('labels.container') }}
                </p>
            </div>
        </div>
        <!--
          <div
          v-if="!isPublic"
          class="mb-1 ml-2">
          <div>
          <span class="bold">
          Share link:
          </span>
          <a
          class="text-blue-500"
          target="_blank"
          :href="sharedUrl">
          {{ sharedUrl }}
          </a>
          </div>
          <div>
          <div class="font-bold">
          {{ $t('labels.journeyList') }}
          </div>
          <div class="text-blue-400 space-x-1">
          <router-link
          v-for="(j, index) in trip.journeys"
          :key="index"
          class="inline-block"
          :to="getJourneyRoute(j)">
          {{ j.code }}
          </router-link>
          </div>
          </div>
          </div>
        -->

        <div class="mx-5 mb-20">
            <div class="py-1">
                <travel-detail
                    v-if="trip.travelDetails"
                    ref="travelDetail"
                    date-format="DD/MM/YYYY"
                    :trip="trip" />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import TravelDetail from './trip-info/travel-detail.vue'
import Status from '~/components/status.vue'
const { $formatters } = useNuxtApp()
const props = defineProps({
  trip: {
    type: Object,
    required: true
  },
  isPublic: Boolean,
  dateFormat: String
})

const { trip } = toRefs(props)

const dataOrder = computed<any>(() => trip.value.order || {})
const sharedUrl = computed(() => {
  return location.protocol + '//' + location.host + `/shared/trip?c=${trip.value?._id}`
})

const getJourneyRoute = (journey: any) => {
  return {
    name: journey.partnerId ? 'c-id-monitoring-partner' : 'c-id-monitoring-owner',
    query: { journeyId: journey._id }
  }
}
defineExpose({})
</script>
